import React from 'react'
import Header from '../../component/Header/Header'
import HomeHero from '../../component/HomeHero/HomeHero'
import Footer from '../../component/Footer/Footer'
import BoxedContent from '../../component/BoxedContent/BoxedContent'
import SlideScrollContent from '../../component/SlideScrollContent/SlideScrollContent'
import BoostCard from '../../component/BoostCard/BoostCard'
import TeamLdCare from '../../component/TeamLdCare/TeamLdCare'
import HomeProgram from '../../component/HomeProgram/HomeProgram'
import BoostshootRowCard from '../../component/BoostshootRowCard/BoostshootRowCard'
import MembershipCustomTextContent from '../../component/MembershipCustomTextContent/MembershipCustomTextContent'
import { Helmet } from 'react-helmet'

const listData = [
     {
        img:"/images/creatives/membership-text-1.png",
        title:"Why it matters",
        para:"When answers are scarce, global collaboration can unlock hope."
    },
     {
        img:"/images/creatives/membership-text-1.2.png",
        title:"Who it’s for",
        para:"Patients with rare diseases, complex conditions, or no clear standard treatment."
    },
     {
        img:"/images/creatives/membership-text-1.3.png",
        title:"How it works",
        para:"TTC coordinates a worldwide panel of experts, reviews your case, and supports you in accessing leading-edge care."
    },
]


const cardList = [
  {
     link:"/dna-clinical-testing",
        img:"/images/creatives/service-main-3.webp",
    name:"DNA Clinical Testing",
    rank:"",
    para:'Discover how your DNA influences risks, metabolism and treatment response.'
  },
  {
     link:"/aging-wellness-clinic",
        img:"/images/creatives/service-main-7.webp",
    name:"Aging and Wellness Clinic",
    rank:"",
    para:'Comprehensive geriatric assessments to support the aging population.'
  },
]

const boostCardData = [
    "Gain opinions from top specialists worldwide",
    "Explore access to experimental and compassionate-use trials",
    "Coordinate advanced diagnostics and genetic insights",
    "Feel supported through a complex medical journey",

]

function GlobalMedicalConsulting() {
  return (
    <div style={{backgroundColor:"#FEFCF0"}}>
      <Helmet>
        <title>
        Global Medical Consulting | The Toronto Clinic
        </title>
        {/* <meta name="keywords" 
        content=""
        ></meta> */}
        <link
          rel="canonical"
          href="https://thetorontoclinic.com/global-medical-consulting"
        />
        <meta
          name="description"
          content="Access world-class care for rare and complex conditions. The Toronto Clinic connects you with global specialists and advanced treatment options for lasting health."
        ></meta>

      </Helmet>
         <Header/>
        <HomeHero
            heading='Global Medical Consulting'
            content='Coordinating world-class expertise for rare and life-altering conditions.'
            textCtaBlack={true}
            headingBlack={true}
            showLogo={false}
            plainCta={false}
             btnText='Book a Consultation'
            btnrefTel='https://booking.thetorontoclinic.com/services-general'
            sideImage={"/images/creatives/healthAssesmenthero-image.png"}
            // bgImage={"/images/creatives/boost-shoot-bg.png"}
            bgImage={"/images/creatives/gradient-bg-3.png"}
            btnCalnedly={true}
            calendlyType={9}
        />

        <div style={{backgroundImage:"url(/images/creatives/boxedGradient-2.png)",backgroundPosition:"top",backgroundSize:"cover",backgroundRepeat:"no-repeat"}}>
          <div className='pt-4'></div>
          <BoxedContent
            heading="Formulas for an empowered you"
            para="For patients facing complex, rare, or treatment-resistant conditions, our Global Medical Consulting service activates a network of top international experts. We collaborate to explore advanced options, including experimental therapies, compassionate-use trials, or innovative multidisciplinary approaches."
            bgImg="/images/creatives/service-main-4.webp"
          />

            <MembershipCustomTextContent
            listData={listData}
            shiftRow={true}
            nonSwitchingImg={true}
          />

        </div>

        {/* <div style={{backgroundImage:"url(/images/creatives/boxedGradient-2.png)",backgroundPosition:"top",backgroundSize:"cover",backgroundRepeat:"no-repeat"}}> */}
        <div style={{backgroundImage:"url(/images/creatives/boost-shoot-bg.png)",backgroundPosition:"center",backgroundSize:"cover",backgroundRepeat:"no-repeat"}}>

        <BoostCard
          cardContentProp={boostCardData}
        />

        
        <div className='pt-4'></div>
       <TeamLdCare
          heading=''
          spanHeading="Enhance your experience"
          paragraph=""
          showBtn={false}
          cardData={cardList}
          noSwiper={true}
       /> 
        <div className='pb-4'></div>
        
        </div>
<div style={{backgroundImage:"url(/images/creatives/boxedGradient-2.png)",backgroundPosition:"bottom",backgroundSize:"cover",backgroundRepeat:"no-repeat"}}>
        <HomeProgram
          mainCardHeading="The path to health begins here, take the first step"
          mainCardPara="At The Toronto Clinic, we redefine healthcare with a proactive, deeply personalized approach. Designed to support your longevity and well-being, our program ensures you stay at your peak: healthy, confident, and in control."
          btnText="Explore membership"
          btnRef="/membership"
          mainCardImg={"/images/creatives/membership-text-2.png"}
          showList={false}
          leftBottomBorderRadius={true}
          backgroundPlain={true}
        />
        
        <Footer
          newsletterSection={false}
        />
        </div>
    </div>
  )
}

export default GlobalMedicalConsulting